import { STATUS_PRIVATE_OFFICE } from "@/constants/status-private-office";

export const handleCategoryName = (name: string): string => {
  const nameMap: { [key: string]: string } = {
    entranceAndAccess: "Entrada e Acesso",
    receptionAndSecurity: "Recepção e Segurança",
    parkingAndTransportation: "Estacionamento e Transporte",
    environmentAndClimateControl: "Ambiente e Climatização",
    structureAndOffice: "Estrutura e Escritório",
    technologyAndConnectivity: "Tecnologia e Conectividade",
    servicesAndSupport: "Serviços de Apoio e Suporte",
    accessibility: "Acessibilidade",
    supportServices: "Serviços de Suporte",
  };
  return nameMap[name] || name;
};

export const privateOfficeStatusOptions: {
  value: string;
  label: string;
}[] = [
  {
    value: STATUS_PRIVATE_OFFICE.AVAILABLE,
    label: "Disponível",
  },
  {
    value: STATUS_PRIVATE_OFFICE.NOT_AVAILABLE,
    label: "Indisponível",
  },
  {
    value: STATUS_PRIVATE_OFFICE.OCCUPED_WITH_WOBA_CLIENT,
    label: "Ocupado com cliente Woba",
  },
  {
    value: STATUS_PRIVATE_OFFICE.RESERVED,
    label: "Reservado",
  },
].map((option) => ({
  ...option,
  value: option.value.toString(),
}));

export const amenitiesStatus = [
  {
    label: "Incluso",
    value: "included",
  },
  {
    label: "Indisponível",
    value: "not-included",
  },
  {
    label: "Cobrado à parte",
    value: "charged",
  },
];

export const privateOfficeCategoryOptions: {
  value: string;
  label: string;
}[] = [
  {
    value: "1",
    label: "Sala Privativa",
  },
  {
    value: "2",
    label: "BTS",
  },
  {
    value: "3",
    label: "Posição Fixa",
  },
  {
    value: "4",
    label: "Endereço Fiscal",
  },
  {
    value: "5",
    label: "Projeto/Proposta",
  },
];
